import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SI_SUPPORT_MAILTO_URL } from '../../../../core/config';
import type { Params, QueryParamsHandling, UrlTree } from '@angular/router';

@Component({
    selector: 'app-nav-item',
    template: `
    <a
      class="nav-item"
      [class.restricted]="restricted"
      [routerLink]="!restricted ? navRouterLink : undefined"
      [queryParams]="!restricted ? navQueryParams : undefined"
      [queryParamsHandling]="navQueryParamsHandling"
      routerLinkActive="active"
      (click)="onClick()"
    >
      <span class="nav-item-text">
        <ng-content></ng-content>
      </span>
      @if (restricted) {
        <mat-tooltip-component class="hidden"></mat-tooltip-component>
        <div class="inline-block restricted-lock-icon relative">
          <fa-icon aria-hidden="true" class="si-icon align-middle" [icon]="['fal', 'lock']"></fa-icon>
          <div class="mdc-tooltip mat-mdc-tooltip mat-mdc-tooltip-show absolute">
            <div class="mat-mdc-tooltip-surface mdc-tooltip__surface">
              @if (restrictedTooltipMessage) {
                {{restrictedTooltipMessage}}
              } @else {
                Email <span class="a" (click)="onOpenSupportEmail()">support&#64;salesintel.io</span> to add {{name}} to your account.
              }
            </div>
          </div>
        </div>
      }
    </a>
  `,
    styleUrls: ['./nav-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NavItemComponent {
  @Input() name: string = '';
  @Input() restricted: boolean = false;
  @Input() navRouterLink: string | any[] | UrlTree | null = null;
  @Input() navQueryParams: Params | null = null;
  @Input() navQueryParamsHandling: QueryParamsHandling | null = null;
  @Input() disabled: boolean = false;
  @Input() restrictedTooltipMessage: string | null = null;
  @Output() clickedEvent: EventEmitter<void> = new EventEmitter<void>();

  onClick(): void {
    if (this.restricted || this.disabled) { return; }
    this.clickedEvent.emit();
  }

  onOpenSupportEmail(): void {
    window.location.href = SI_SUPPORT_MAILTO_URL;
  }
}
